import style from "./style.scss";

const thanksTemplate = document.createElement("template");
thanksTemplate.innerHTML = /* html */ `
  <style>${style}</style>
  <div class="content">
    <span id="close" class="close">
      x
    </span>
    <p class="mb-auto mt-auto text-center">Thank you so much!</p>
  </div>
`;

export { thanksTemplate };
